import { logEvent } from "@src/appV2/lib/analytics";
import { REFERRAL_POST_BOOKING_CTA_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { Button } from "@src/appV2/redesign/components/Button";
import { WORKER_REFERRALS_SHARE_LINK_PATH_FULL } from "@src/appV2/Referral/path";
import { useHistory } from "react-router-dom";

import { useReferralPostBookingCta } from "./useReferralPostBookingCta";

interface ReferralPostBookingCtaProps {
  shiftId: string;
  workplaceId: string;
  workplaceType: string | undefined;
  msa: string | undefined;
}

export function ReferralPostBookingCta(props: ReferralPostBookingCtaProps) {
  const { shiftId, workplaceId, workplaceType, msa } = props;
  const history = useHistory();

  const { isEligible } = useReferralPostBookingCta({ workplaceType });

  const eventProperties = { shiftId, workplaceId, workplaceType, msa };

  useLogEffect(REFERRAL_POST_BOOKING_CTA_EVENTS.REFERRAL_POST_BOOKING_CTA_VIEWED, eventProperties, {
    enabled: isEligible,
  });

  if (!isEligible) {
    return null;
  }

  return (
    <Button
      fullWidth
      variant="outlined"
      size="large"
      onClick={() => {
        logEvent(
          REFERRAL_POST_BOOKING_CTA_EVENTS.REFERRAL_POST_BOOKING_CTA_CLICKED,
          eventProperties
        );
        history.push(WORKER_REFERRALS_SHARE_LINK_PATH_FULL);
      }}
    >
      Refer a friend, earn $150
    </Button>
  );
}
